import { type Held, heldFor } from "./held.ts";

const MOST = 12;

export type Shelf<T> = {
  keep(conversation: string, what: T): void;

  recall(conversation: string): T | null;

  has(conversation: string): boolean;

  forget(conversation: string): void;

  drawn(held: Held<T>, conversation: string): Held<T>;
};

const shelves = new Set<{ clear: () => void }>();

export function shelfFor<T>(): Shelf<T> {
  const kept = new Map<string, T>();
  shelves.add({ clear: () => kept.clear() });
  return {
    keep(conversation, what) {
      kept.delete(conversation);
      kept.set(conversation, what);

      while (kept.size > MOST) {
        const oldest = kept.keys().next().value;
        if (oldest === undefined) break;
        kept.delete(oldest);
      }
    },
    recall(conversation) {
      return kept.has(conversation) ? (kept.get(conversation) as T) : null;
    },
    has(conversation) {
      return kept.has(conversation);
    },
    forget(conversation) {
      kept.delete(conversation);
    },
    drawn(held, conversation) {
      const mine = heldFor(held, conversation);
      if (mine.state !== "loading") return mine;
      const copy = kept.has(conversation) ? (kept.get(conversation) as T) : null;
      if (copy === null) return mine;

      return { for: conversation, state: "read", what: copy };
    },
  };
}

export function forgetEverything(): void {
  for (const shelf of shelves) shelf.clear();
}
